import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t bg-background h-10">
      <div className="container mx-auto px-4 max-w-7xl flex items-center justify-center h-10">
        <p className="text-sm text-muted-foreground text-center">
          &copy; {new Date().getFullYear()} Interview Assistant.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
